import React from 'react';
import {connect} from "react-redux";
import PropTypes from 'prop-types';
import moment from 'moment';

import UserFieldElement from '../../../reusable/UserFieldElement';
import UserFieldDataType from "../../../../utils/enums/UserFieldDataTypeEnum";
import { formatNullable } from "../../../../../../common/src/util/dataUtil";
import config from "../../../../../../server/src/config";

import * as AdminActions from "../../../../actions/admin";
import {confirm} from "../../../../utils/confirmDialog";
import {NotificationManager} from "react-notifications";
import UserRoles from "../../../../../../common/src/enums/UserRoles";
import {replace} from "react-router-redux";
import {ROUTE_PIGEON_HOLE} from "../../../../constants/routeconstants";

class PigeonHolePigeons extends React.Component {

    static propTypes = {
        pigeonhole: PropTypes.object,
    };

    constructor(props) {
        super(props);
        this.state = {
            editIx: null,
            selected: [],
            defaultSelected: false,
            serieFrom: "",
            serieTo: "",
            gender: "",
        };
    }

    pigeonFields = [];
    seriesFields = [];
    groupFields = [];
    render() {
        return <div className={"form-page pigeon-hole-pigeons"}>
            <div className={"left-panel"}>
                <div id={"data-table"} className={"top-panel"}>
                    <table className="data-table">
                        <thead>
                        <th></th>
                        <th>Ringnummer</th>
                        <th>Køn</th>
                        <th></th>
                        </thead>
                        <tbody>
                            {this.props.pigeonhole.Duer.sort((p1, p2) => {
                                const result = p1.Ringnummer.substr(-4).localeCompare(p2.Ringnummer.substr(-4), "da-DK");
                                if (result !== 0) return result;
                                return p1.Ringnummer.localeCompare(p2.Ringnummer, "da-DK");
                            }).concat(this.state.editIx === 'new' ? [{Ringnummer: 'new', Koen: 'X'}] : []).map(pigeon => <tr key={pigeon.Ringnummer} id={'row-' + pigeon.Ringnummer}>
                                <td>
                                    <input type="checkbox" checked={!this.state.defaultSelected === this.state.selected.includes(pigeon.Ringnummer)} disabled={this.state.editIx !== null} onChange={(e) => {
                                        const ix = this.state.selected.indexOf(pigeon.Ringnummer);
                                        if (ix > -1) this.state.selected.splice(ix, 1);
                                        else this.state.selected.push(pigeon.Ringnummer);
                                        this.forceUpdate();
                                    }}/>
                                </td>
                                <td>{
                                    this.state.editIx === pigeon.Ringnummer ? <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field150" containerClassName="display-inline-block"
                                                                                                name="Ringnummer" id="Ringnummer" maxLength="11" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY, value: "^[0-9]{3}-[0-9]{2}-[0-9]{4}$"}]} value={this.state.Ringnummer}
                                                                                                autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                                                                onChange={this.onRingChange}
                                                                                                ref={instance => { this.pigeonFields[0] = instance; }}
                                    /> : pigeon.Ringnummer
                                }</td>
                                <td>{
                                    this.state.editIx === pigeon.Ringnummer ? <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field50" containerClassName="display-inline-block" title={"A=Han, U=Hun, X=Unge"}
                                                                                                name="Koen" id="Koen" maxLength="1" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY, value: "^[AUX]$"}]} value={this.state.Koen}
                                                                                                autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                                                                onChange={this.onUpperCaseFieldChange}
                                                                                                onKeyPress={this.onGenderKeyPress}
                                                                                                ref={instance => { this.pigeonFields[1] = instance; }}
                                    /> : pigeon.Koen
                                }</td>
                                <td>{
                                    this.state.editIx === pigeon.Ringnummer ? [
                                        <i key={0} className="fa fa-save clickable" title="Gem due" onClick={this.saveRow}/>,
                                        <i key={1} className="fa fa-undo clickable" title="Annuller" onClick={this.cancelEdit}/>
                                    ] : [
                                        <i key={0} className={"fa fa-pencil " + (this.state.editIx === null ? 'clickable' : 'disabled')} title="Rediger due" onClick={() => {
                                            if (this.state.editIx === null){
                                                this.setState({
                                                    Ringnummer: pigeon.Ringnummer,
                                                    Koen: pigeon.Koen,
                                                    editIx: pigeon.Ringnummer,
                                                });
                                            }
                                        }}/>,
                                        <i key={1}
                                           className={"fa fa-trash " + (this.state.editIx === null ? 'clickable' : 'disabled')} title="Slet due" onClick={() => {
                                            if (this.state.editIx === null) confirm("Slet", <span>Ønsker du at slette ringnummer <b>{pigeon.Ringnummer}</b>?</span>, () => {
                                                this.props.dispatch(AdminActions.deletePigeon(pigeon.Ringnummer,   () => {
                                                    NotificationManager.success("Ringnummer " + pigeon.Ringnummer + " er slettet.", "Sletning", 4000);
                                                }));
                                            });
                                        }}/>
                                    ]
                                }</td>
                            </tr>)}
                        </tbody>
                    </table>
                </div>
                <div className={"bottom-panel"}>
                    <button className="btn-primary" title="Opret ny due" disabled={this.state.editIx !== null} onClick = {this.createNew}>Ny</button>
                </div>
            </div>
            <div className={"right-panel"}>
                <div className={"first-section counters"}>
                    <table>
                        <tbody>
                        <tr>
                            <td className={"label"}>Antal duer</td>
                            <td className={"value"}>{this.props.pigeonhole.Duer.length}</td>
                        </tr>
                        <tr>
                            <td className={"label"}>Antal aktive</td>
                            <td className={"value"}>{this.props.pigeonhole.Duer.filter(pigeon => pigeon.Aktiv !== null).length}</td>
                        </tr>
                        <tr>
                            <td className={"label"}>Antal unger</td>
                            <td className={"value"}>{this.props.pigeonhole.Duer.filter(pigeon => pigeon.Koen === "X").length}</td>
                        </tr>
                        <tr>
                            <td className={"label"}>Antal aktive unger</td>
                            <td className={"value"}>{this.props.pigeonhole.Duer.filter(pigeon => pigeon.Aktiv !== null && pigeon.Koen === "X").length}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div className={"middle-section group-updates"}>
                    <table>
                        <tbody>
                        <tr className={"header-row"}>
                            <td colspan={2}><label>Nummerserier</label></td>
                        </tr>
                        <tr className={"form-row"}>
                            <td>
                                <label htmlFor="serieFrom">Start</label>
                            </td>
                            <td>
                                <UserFieldElement dataType={UserFieldDataType.int} placeholder="" className="field75" containerClassName="display-inline-block"
                                                  name="serieFrom" id="serieFrom" maxLength="4"
                                                  autoCheckErrors={false} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                  isError={!(new RegExp("^[0-9]{1,4}$")).test(this.state.serieFrom) || parseInt(this.state.serieFrom) < 1 || parseInt(this.state.serieFrom) > 9999}
                                                  errorMessageOverride="Skal være et heltal mellem 1 og 9999."
                                                  onChange={this.onStandardFieldChange} value={this.state.serieFrom}
                                                  ref={instance => { this.seriesFields[0] = instance; }}
                                />
                            </td>
                        </tr>
                        <tr className={"form-row"}>
                            <td>
                                <label htmlFor="serieTo">Slut</label>
                            </td>
                            <td>
                                <UserFieldElement dataType={UserFieldDataType.int} placeholder="" className="field75" containerClassName="display-inline-block"
                                                  name="serieTo" id="serieTo" maxLength="4"
                                                  autoCheckErrors={false} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                  isError={!(new RegExp("^[0-9]{1,4}$")).test(this.state.serieTo) || parseInt(this.state.serieTo) < 1 || parseInt(this.state.serieTo) > 9999 || (
                                                      (new RegExp("^[0-9]{1,4}$")).test(this.state.serieFrom) && parseInt(this.state.serieFrom) > parseInt(this.state.serieTo)
                                                  )}
                                                  errorMessageOverride={"Skal være et heltal mellem " + ((new RegExp("^[0-9]{1,4}$")).test(this.state.serieFrom) ? parseInt(this.state.serieFrom) : 1) + " og 9999."}
                                                  onChange={this.onStandardFieldChange} value={this.state.serieTo}
                                                  ref={instance => { this.seriesFields[1] = instance; }}
                                />
                            </td>
                        </tr>
                        <tr className={"action-row"}>
                            <td colSpan={2}>
                                <button className="btn-primary" title="Opret nummerserie" disabled={this.state.editIx !== null} onClick = {this.createRings}>Opret ringnumre</button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div className={"last-section group-updates"}>
                    <table>
                        <tbody>
                        <tr className={"header-row"}>
                            <td colSpan={2}><label>Gruppeopdatering</label></td>
                        </tr>
                        <tr className={"form-row"}>
                            <td>
                                <label htmlFor="gender">Køn</label>
                            </td>
                            <td>
                                <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field50" containerClassName="display-inline-block" title={"A=Han, U=Hun, X=Unge"}
                                                  name="gender" id="gender" maxLength="1" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY, value: "^[AUX]$"}]} value={this.state.gender}
                                                  autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                  onChange={this.onUpperCaseFieldChange}
                                                  onKeyPress={this.onGenderKeyPress}
                                                  ref={instance => { this.groupFields[0] = instance; }}
                                />
                            </td>
                        </tr>
                        <tr className={"action-row"}>
                            <td colSpan={2}>
                                <button className="btn-primary" title={this.state.defaultSelected ? "Fjern alle duemarkeringer" : "Marker alle duer"} onClick={() => {
                                    this.setState({
                                        defaultSelected: !this.state.defaultSelected,
                                        selected: []
                                    })
                                }}>
                                    {this.state.defaultSelected ? "Fjern markeringer" : "Marker alle"}
                                </button>
                                <button className="btn-primary" title="Opdater alle markerede duer"
                                        disabled={
                                            this.state.editIx !== null ||
                                            (this.state.gender === "") ||
                                            (this.state.defaultSelected && this.state.selected.length >= this.props.pigeonhole.Duer.length) ||
                                            (!this.state.defaultSelected && this.state.selected.length <= 0)
                                        } onClick={this.updateRings}>
                                    Opdater markerede
                                </button>
                                <button className="btn-dangerous" title="Slet alle markerede duer"
                                        disabled={
                                            this.state.editIx !== null ||
                                            (this.state.defaultSelected && this.state.selected.length >= this.props.pigeonhole.Duer.length) ||
                                            (!this.state.defaultSelected && this.state.selected.length <= 0)
                                        } onClick={this.deleteRings}>
                                    Slet markerede
                                </button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    }

    onStandardFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.value});
    };

    onRingChange = (e) => {
        const stateVariable = e.target.name;
        if ((new RegExp("^[0-9]{9}$")).test(e.target.value)) {
            this.setState({[stateVariable]: e.target.value.substr(0, 3) + "-" + e.target.value.substr(3, 2) + "-" + e.target.value.substr(-4)});
        } else this.setState({[stateVariable]: e.target.value});
    };

    onUpperCaseFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.value.toUpperCase()});
    };

    onGenderKeyPress = (e) => {
        const stateVariable = e.target.name;
        switch (e.key) {
            case 'a':
            case 'A':
                console.log("AAAA");
                this.setState({[stateVariable]: "A"});
                e.preventDefault();
                break;
            case 'u':
            case 'U':
                this.setState({[stateVariable]: "U"});
                e.preventDefault();
                break;
            case 'x':
            case 'X':
                this.setState({[stateVariable]: "X"});
                e.preventDefault();
                break;
            case ' ':
                if (this.state[stateVariable] === "A") this.setState({[stateVariable]: "U"});
                else if (this.state[stateVariable] === "U") this.setState({[stateVariable]: "X"});
                else this.setState({[stateVariable]: "A"});
                e.preventDefault();
                break;
        }
        console.log("Event", e.key);
    };

    allInputValid = (fields) => {
        let result = true;
        fields.forEach((field) => {
            if (field && !field.isValid()) result = false;
        });
        return result;
    };

    saveRow = () => {
        if (this.allInputValid(this.pigeonFields)) {
            const entity = {
                Ringnummer: this.state.Ringnummer,
                Koen: this.state.Koen,
            };
            if (this.state.editIx === 'new') {
                entity.Foreningsnr = this.props.pigeonhole.Foreningsnr;
                entity.Slagnr = this.props.pigeonhole.Slagnr;
                this.props.dispatch(AdminActions.createPigeon(entity, () => {
                    NotificationManager.success("Ringnummer " + this.state.Ringnummer + " er oprettet.", "Oprettelse", 4000);
                    this.setState({editIx: null});
                }));
            } else this.props.dispatch(AdminActions.updatePigeon(this.state.editIx,  entity, () => {
                NotificationManager.success("Ringnummer " + this.state.Ringnummer + " er opdateret.", "Opdatering", 4000);
                this.setState({editIx: null});
            }));
        } else {
            this.pigeonFields.forEach((field) => {
                field.setState({visited: true});
            });
        }
    };

    createRings = () => {
        if (this.allInputValid(this.seriesFields)) {
            this.props.dispatch(AdminActions.createPigeons(this.props.pigeonhole.Foreningsnr, this.props.pigeonhole.Slagnr, this.state.serieFrom, this.state.serieTo, () => {
                NotificationManager.success("Ringserien er oprettet.", "Oprettelse", 4000);
            }));
        } else {
            this.seriesFields.forEach((field) => {
                field.setState({visited: true});
            });
        }
    };

    updateRings = () => {
        if (this.allInputValid(this.groupFields)) {
            const rings = this.props.pigeonhole.Duer.filter(pigeon => !this.state.defaultSelected === this.state.selected.includes(pigeon.Ringnummer)).map(pigeon => pigeon.Ringnummer);
            confirm("Opdatering", <span>Ønsker du at opdatere {rings.length} duer?</span>, () => {
                const input = {
                    Data: {},
                    Ringnumre: rings
                };
                if (this.state.gender !== "") input.Data.Koen = this.state.gender;
                this.props.dispatch(AdminActions.updatePigeons(this.props.pigeonhole.Foreningsnr, this.props.pigeonhole.Slagnr, input,   () => {
                    NotificationManager.success(rings.length + " duer er opdateret.", "Opdatering", 4000);
                }));
            });
        } else {
            this.groupFields.forEach((field) => {
                field.setState({visited: true});
            });
        }
    };

    deleteRings = () => {
        const rings = this.props.pigeonhole.Duer.filter(pigeon => !this.state.defaultSelected === this.state.selected.includes(pigeon.Ringnummer)).map(pigeon => pigeon.Ringnummer);
        confirm("Slet", <span>Ønsker du at slette {rings.length} ringnumre?</span>, () => {
            this.props.dispatch(AdminActions.deletePigeons(this.props.pigeonhole.Foreningsnr, this.props.pigeonhole.Slagnr, {
                Ringnumre: rings
            },   () => {
                NotificationManager.success(rings.length + " ringnummre er slettet.", "Sletning", 4000);
                if (!this.state.defaultSelected) this.setState({selected: []});
            }));
        });
    };

    createNew = () => {
        this.setState({
            Ringnummer: '',
            Koen: 'X',
            editIx: 'new'
        });
        setTimeout(function () {
            const content = document.getElementById("data-table");
            content.scrollTop = content.scrollHeight;
        });
    };

    cancelEdit = () => {
        this.setState({editIx: null});
    };
}

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, null, null, {withRef: true})(PigeonHolePigeons);



// WEBPACK FOOTER //
// ./src/client/src/components/pages/club/subPages/PigeonHolePigeons.js